import React from 'react';
import { Box } from '@mui/material';
import PillarComparison from './PillarComparison';
import { SectionCard, SectionHeader } from './ui/Section';

interface PillarComparisonSectionProps {
  platforms: string[];
}

const PillarComparisonSection: React.FC<PillarComparisonSectionProps> = ({
  platforms,
}) => {
  return (
    <SectionCard>
      <SectionHeader
        title="Brand Pillar Comparison"
        info="Select a Brand and Pillar to view Post Volume, Total Engagement, and Average Sentiment over the page's selected date range. The chart on the right is a duplicate, and allows you to easily compare to another selection of Brand and Pillar."
        description="Pick a brand and pillar on each side to compare post volume or total engagement over the selected dates."
      />

      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2 }}>
        <PillarComparison platforms={platforms} />
        <PillarComparison platforms={platforms} />
      </Box>
    </SectionCard>
  );
};

export default PillarComparisonSection;
